<!-- Person Item -->
<div *ngIf="personMode" class="unset">
  <div class="personItem header-person unset" [ngClass]="{ 'cursor-pointer': hasUserCard }" (click)="
      model.clickItem(); toggleDropdown(); hasUserCard && toggleUserCard($event)" #personItemAvatar>

    <div class="avatar" [ngClass]="{
        'no-cursor': model.noCursor && !hasUserCard,
        'cursor-pointer': hasUserCard
      }"
    >
      <ng-container [ngSwitch]="iconType">
        <span class="avatar-icon" *ngSwitchCase="'chairman'">
          <i class="avatar-icon-i bx bxs-user {{ language }}-icon"></i>
        </span>
        <img class="medal {{ language }}-medal" *ngIf="model.data?.icon" [src]="model.data?.icon?.fileUrl" alt="" />
        <img *ngSwitchCase="'medal'" class="medal" src="/assets/img/1st-medal.svg" alt="" />
        <span *ngSwitchDefault></span>
      </ng-container>
      <!-- <img
        class="medal {{ language }}-medal"
        *ngIf="model.data?.icon"
        [src]="model.data?.icon?.fileUrl"
        alt=""
      /> -->

      <ng-container [ngTemplateOutlet]="avatar"></ng-container>
    </div>

    <angular-popper
      *ngIf="hasUserCard"
      [show]="displayUserCard"
      [target]="personItemAvatar"
      [positionFixed]="isUserCardFixed"
    >
      <div class="user-popup-card" content>
        <div class="avatar">
          <ng-container [ngTemplateOutlet]="avatar"></ng-container>
        </div>

        <div class="info">
          <div class="name info-item">
            {{
              isTwoWordsOnly
                ? model.LangName.split(" ").slice(0, 2).join(" ")
                : (model.LangName | titlecase)
            }}
          </div>

          <div class="email info-item" *ngIf="model.data?.email">
            <div class="copy-text" #email>
              {{ model.data?.email }}
            </div>

            <button
              class="copy-btn"
              [title]="'shared.copyEmail' | translate"
              [copyToClipboard]="email"
            >
              <i class="bx bx-copy"></i>
              <i class="bx bxs-copy"></i>
            </button>
          </div>

          <div class="job info-item" *ngIf="model.data?.position">
            {{ language == 'ar' && model.data?.arabicPosition ? model.data?.arabicPosition : model.data?.position }}
          </div>
        </div>
      </div>
    </angular-popper>

    <!-- Info -->
    <div
      style="display: flex; flex-direction: column"
      class="info"
      #toggleButton
    >
      <p class="name">
        {{
          isTwoWordsOnly
            ? model.LangName.split(" ").slice(0, 2).join(" ")
            : (model.LangName | titlecase)
        }}
      </p>
      <span class="job">{{ language == 'ar' && model.data?.arabicPosition ? model.data?.arabicPosition :
        model.data?.position }}</span>
    </div>

    <ng-template #avatar>
      <img class="user-img" *ngIf="model.getImage()" [src]="model.getImage()" />
      <!-- <img src="assets/img/excel.png"/> -->
      <!-- *ngIf="!model.getImage() && model.data?.backgroundColor && model.data?.name" -->
      <div
        *ngIf="
          !model.getImage() && model.data?.backgroundColor && model.LangName
        "
        class="letters"
        [style.background]="model.data?.backgroundColor || '#00bbb0'"
      >
        {{ model.Name | titlecase }}
      </div>
    </ng-template>
  </div>

  <!-- profile dropdown menu -->
  <div
    id="profileDropdown"
    class="profile-dropdown"
    #dropdown
    *ngIf="displayDropdown"
  >
    <!-- profile details -->
    <div class="profile-dropdown-details">
      <div class="profile-image">
        <img [src]="model.getImage()" *ngIf="model.getImage()" />
        <span class="initials" *ngIf="!model.getImage()">
          {{ model.LangName | initials }}
        </span>

        <input
          *ngIf="isAllowedToChangePhoto"
          type="file"
          [id]="uniqueId || 'fileInput'"
          [title]="'shared.uploadImage' | translate"
          [disabled]="model.isImageUploading"
          (change)="model.uploadFile($event)"
        />

        <div
          class="background"
          *ngIf="isAllowedToChangePhoto"
          [ngStyle]="{ display: model.isImageUploading ? 'flex' : '' }"
          [ngClass]="{ 'no-cursor': model.noCursor }"
        >
          <i class="bx bx-upload" *ngIf="!model.isImageUploading"></i>
        </div>
      </div>
      <span class="fullname">{{ model.LangName }}</span>
      <span class="position">{{ language == 'ar' && model.data?.arabicPosition ? model.data?.arabicPosition : model.data?.position }}</span>
      <span class="version">v2.0.16</span>
    </div>

    <!-- profile actions -->
    <ul class="profile-dropdown-actions">
      <!-- <li class="profile-dropdown-actions-item settings">
        <a class="profile-dropdown-actions-link" routerLink="/settings">
          <i class="bx bx-cog"></i>
          <span>{{ 'shared.settings' |translate }}</span>
        </a>
      </li> -->
      <!--      <li class="profile-dropdown-actions-item scoreSheet ">-->
      <!--        <a class="d-flex align-items-center"  href="/employee-appraisal/planning-details/{{model?.data?.id}}?year=2024&periodId={{currentPeriodId}}">-->
      <!--          <i class="bx bx-notepad text-primary"></i>-->
      <!--          <span>{{'shared.scoreSheet' | translate}}</span>-->
      <!--        </a>-->
      <!--      </li>-->
      <li class="profile-dropdown-actions-item reset-password" (click)="openResetPasswordModal()"
      [translatable]="{
        transKey: 'shared.resetPassword',
        modEnum: translationModulesEnum.shared
      }">
        <i class="bx bx-lock-open"></i>
        <span>{{ 'shared.resetPassword' | translate }}</span>
      </li>
      <li class="profile-dropdown-actions-item logout" (click)="onLogout()">
        <i class="bx bx-log-out"></i>
        <span>{{ "shared.logout" | translate }}</span>
      </li>
    </ul>
  </div>
</div>

<!-- Owner Item -->
<div *ngIf="ownerMode">
  <div
    class="personItem"
    [ngClass]="{ 'cursor-pointer': hasUserCard }"
    (click)="model.clickItem(); hasUserCard && toggleUserCard($event)"
    #personItemAvatar
  >
    <div class="avatar">
      <ng-container [ngTemplateOutlet]="avatar"></ng-container>
    </div>

    <angular-popper
      *ngIf="hasUserCard"
      [show]="displayUserCard"
      [target]="personItemAvatar"
      [positionFixed]="isUserCardFixed"
    >
      <div class="user-popup-card" content>
        <div class="avatar">
          <ng-container [ngTemplateOutlet]="avatar"></ng-container>
        </div>

        <div class="info">
          <div class="name info-item">
            {{
              language == "ar"
                ? (model.ownerData?.name?.ar | titlecase)
                : (model.ownerData?.name?.en | titlecase)
            }}
          </div>

          <div class="email info-item" *ngIf="model.ownerData?.email">
            <div class="copy-text" #email>
              {{ model.ownerData?.email }}
            </div>

            <button
              class="copy-btn"
              [title]="'shared.copyEmail' | translate"
              [copyToClipboard]="email"
            >
              <i class="bx bx-copy"></i>
              <i class="bx bxs-copy"></i>
            </button>
          </div>

          <div class="job info-item" *ngIf="model.ownerData?.position">
            {{ language == 'ar' && model.ownerData?.arabicPosition ? model.ownerData?.arabicPosition
            :model.ownerData?.position }}
          </div>
        </div>
      </div>
    </angular-popper>

    <!-- Info -->
    <div>
      <p class="name">
        {{
          language == "ar"
            ? (model.ownerData?.name?.ar | titlecase)
            : (model.ownerData?.name?.en | titlecase)
        }}
      </p>
      <span class="job" *ngIf="model.ownerData?.position">
        {{ language == 'ar' && model.ownerData?.arabicPosition ? model.ownerData?.arabicPosition :
        model.ownerData?.position }}
      </span>
    </div>

    <ng-template #avatar>
      <img
        *ngIf="model.getImage()"
        [src]="model.getImage()"
        width="50"
        height="50"
      />
      <div
        *ngIf="!model.getImage()"
        class="letters"
        [style.background]="model.data?.backgroundColor || '#00bbb0'"
      >
        {{ model.ownerName | titlecase }}
      </div>
    </ng-template>
  </div>
</div>

<!-- name only -->
<div *ngIf="nameMode">
  <span class="fullname fw-bold text-primary">{{ model.LangName }}</span>
</div>
